import {Palette} from 'hubbl-shared';
import {useCallback} from 'react';
import {Api} from '../../../../api';
import {AssetIconLogOut} from '../../../../assets';
import {persistor} from '../../../../store';
import {IconButton} from '../../../buttons/icon-button/IconButton';
import {useI18n} from '../../../../hooks';

interface MenuItemsContainerProps {
  isCollapsed: boolean;
}

export const SidebarFooter = ({isCollapsed}: MenuItemsContainerProps) => {
  const t = useI18n();
  const onLogout = useCallback(async () => {
    await Api.user.onLogOut();
    await persistor.purge();
    window.location.reload();
  }, []);

  return (
    <div style={{paddingBottom: 64, justifyContent: 'center', display: 'flex'}}>
      <IconButton
        color={Palette.systemError}
        icon={<AssetIconLogOut color={Palette.systemError} />}
        text={isCollapsed ? undefined : t.auth.logout}
        onClick={onLogout}
        hoverColor={Palette.whiteTransparent60}
      />
    </div>
  );
};
